module.exports = __webpack_public_path__ + "static/img/feedback.86f884b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/feedback.svg
// module id = t64x
// module chunks = 1